/*  ========================================================================
    # JavaScript - Flynt
    ========================================================================  */

import loader from 'uce-loader';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/native-loading/ls.native-loading';

/**
 * Dynamic import feather-icons and replace all elements
 * that have a data-feather attribute with SVG markup
 * only if markup exits inside the document.
 */
export function initFeatherIcons() {
  const dataFeather = document.querySelector('[data-feather]');
  if (dataFeather) {
    import('feather-icons').then(feather => feather.replace());
  }
}

/**
 * Add feather icon markup to the
 * class .iconList--checkCircle
 */
export function addFeatherIconToListCheckCircle() {
  const iconListCheckCircleElements = document.querySelectorAll('.iconList--checkCircle');
  iconListCheckCircleElements.forEach(element => {
    const children = [...element.children];
    children.forEach(child => {
      child.insertAdjacentHTML('afterbegin', '<i data-feather=check-circle></i>');
    });
  });
}

function isPartInViewport(el) {
  const rect = el.getBoundingClientRect();
  const elementHeight = el.offsetHeight;
  const elementWidth = el.offsetWidth;

  return (
    rect.top >= -elementHeight &&
    rect.left >= -elementWidth &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) + elementWidth &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + elementHeight
  );
}

/**
 * Prepare content that lazy loaded and above/inside the fold.
 */
function prepareAboveTheFoldLazyLoadedElements() {
  // Add preload class to lazy loaded elements when they are above the fold.
  const aboveTheFoldElements = document.querySelectorAll('.lazyload');
  aboveTheFoldElements.forEach(element => {
    if (isPartInViewport(element)) {
      element.classList.add('lazypreload');
    }
  });

  // Remove loading tag if it exits.
  if (aboveTheFoldElements.length > 0) {
    window.addEventListener('lazybeforeunveil', e => {
      const element = e.target;
      if (isPartInViewport(element)) {
        if ('loading' in element && element.getAttribute('loading') === 'lazy') {
          element.removeAttribute('loading');
        }
      }
    });
  }
}

lazySizes.cfg.nativeLoading = { setLoadingAttribute: true, disableListeners: { scroll: true } };
prepareAboveTheFoldLazyLoadedElements();

document.addEventListener('DOMContentLoaded', () => {
  addFeatherIconToListCheckCircle();
  initFeatherIcons();
});

function capitalize(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function kebabToCamel(input) {
  return capitalize(
    input.replace(/-([a-z])/g, g => {
      return g[1].toUpperCase();
    })
  );
}

// Dynamic import component scripts
loader({
  container: document.body,

  async on(newTag) {
    const componentName = kebabToCamel(newTag).replace('Flynt', '');
    const componentSubpath = window.FlyntData.componentsWithScript[componentName];

    if (window.FlyntData.componentsWithScript[componentName]) {
      import(`../../theme/Components/${componentSubpath}/script.js`);
    }
  }
});
